<template>
  <div>
    คุณต้องการรับลิงก์เพื่อรีเซ็ตรหัสผ่านที่อีเมลด้านล่างใช่ไหม ?
    <v-form ref="form" v-model="valid">
      <v-row>
        <v-col>
          <v-text-field
            type="email"
            name="email"
            label="อีเมล"
            v-model="mEmail"
            outlined
            required
          ></v-text-field>
        </v-col>
      </v-row>
    </v-form>
    <save-alert
      :status="
        changePasswordStatus &&
          (changePasswordStatus === 'success' ? 'success' : 'error')
      "
      :error-text="alertText[changePasswordStatus]"
      success-text="กรุณาตรวจสอบอีเมลเพื่อเปลี่ยนรหัสผ่านของคุณ"
    ></save-alert>
    <div class="tw-text-right" v-if="!forgotNoLogin">
      <v-btn color="black darken-1" text @click="closeDialog()">
        <v-icon left>mdi-close-circle-outline</v-icon>
        ยกเลิก
      </v-btn>
      <v-btn color="green darken-1" text @click="submit" :disabled="loading">
        <v-icon left>mdi-plus-circle-outline</v-icon>
        ดำเนินการต่อ
      </v-btn>
    </div>
    <div v-if="forgotNoLogin">
      <v-card-actions style="width: 70%; margin: 0 auto;">
        <v-btn
          color="primary"
          type="submit"
          class="tw-font-bold"
          block
          @click="submit"
          :disabled="loading"
          >ลืมรหัสผ่าน</v-btn
        >
      </v-card-actions>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import firebase from "firebase";
import SaveAlert from "../save-alert";

export default {
  name: "ResetPassword",
  props: ["closeDialog", "dialog", "forgotNoLogin"],
  components: {
    SaveAlert
  },
  computed: mapState({
    loading: state => state.user.loading,
    userProfile: state => state.user.userProfile,
    changePasswordStatus: state => state.user.changePasswordStatus
  }),
  data() {
    return {
      valid: true,
      mEmail: "",
      emailRules: [v => !!v || "กรุณากรอกอีเมล"],
      alertText: {
        error: "ส่งอีเมลไม่สำเร็จ กรุณาลองใหม่อีกครั้ง",
        authError: "อีเมลไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง"
      }
    };
  },
  watch: {
    dialog: {
      handler: function() {
        if (this.dialog === false) {
          this.clearState();
          this.$store.dispatch("user/setChangePasswordStatus", { status: "" });
        }
      },
      deep: true
    },
    changePasswordStatus: {
      handler: function() {
        if (this.changePasswordStatus === "success") {
          this.clearState();
        }
      },
      deep: true
    }
  },
  methods: {
    submit: function() {
      this.$store.dispatch("user/setChangePasswordStatus", { status: "" });
      let _this = this;
      console.log(this.mEmail)
      firebase
        .auth()
        .sendPasswordResetEmail(this.mEmail)
        .then(function() {
          _this.$store.dispatch("user/setChangePasswordStatus", {
            status: "success"
          });
        })
        .catch(function(error) {
          console.log('error', error)
          _this.$store.dispatch("user/setChangePasswordStatus", {
            status: "error"
          });
        });
    },
    clearState: function() {
      this.valid = true;
      this.$refs.form.resetValidation();
    }
  }
};
</script>
